var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.dataset && _vm.dataset.md)?_c('Markdown',{staticClass:"mt-4",attrs:{"title":_vm.dataset.title,"content":_vm.dataset.md,"content_en":_vm.dataset.md,"lang":_vm.$i18n.locale}}):_c('S404')
}
var staticRenderFns = []

export { render, staticRenderFns }